import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkConfig } from 'app/providers/StoreProvider';

export const fetchSourcingModes = createAsyncThunk<
    { data: string[] },
    void,
    ThunkConfig<string>
>('fetchSourcingModes', async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<{ data: string[] }>(
            `/v1/product_sourcing/settings/sourcing-modes`,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
